import { Component, OnInit } from "@angular/core";
import { FORM_DIRECTIVES, FORM_PROVIDERS, REACTIVE_FORM_DIRECTIVES } from "@angular/forms";
import { AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS } from "ng2-bootstrap/ng2-bootstrap";
import { ClientDocument } from "../../domain/clientDocument";
import { Dragula, DragulaService } from "ng2-dragula/ng2-dragula";
import { ClientDocumentService } from "../../service/clientDocument.service";
import { FileUploader, FILE_UPLOAD_DIRECTIVES } from "ng2-file-upload/ng2-file-upload";
import { FILE_MAX_SIZE } from "../../validators/validators";

import { LoginService } from '../../service/login.service';
import { User } from '../../domain/user';
import { Bank } from "../../domain/bank";
import { BankService } from "../../service/bank.service";
import { ChangeDetectorRef } from '@angular/core';

/**
 * .
 * Created by jlado on 6/9/16.
 */
@Component( {
    selector: 'config-clientPatentDocuments',
    template: require( '../clientFiles/config.clientDocuments.component.html' ),
    styles: [require( '../clientFiles/config.clientDocuments.component.css' )],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES,
        Dragula
    ],
    providers: [FORM_PROVIDERS],
    viewProviders: [
        BS_VIEW_PROVIDERS,
        DragulaService
    ],
} )
export class ConfigClientPatentDocumentsComponent implements OnInit {
    private pageHeader: string;
    private data: ClientDocument[];

    public clientDocumentSelected: ClientDocument;
    private clientDocumentUploading: any;

    public uploaderClientDocument: FileUploader;
    public hasClientDocumentDropZoneOver: boolean;

    public successMessage: string;
    public error: any;

    private bankId: string;
    public isAdmin: boolean;
    public isBank: boolean;
    private userLogged: User;
    private disableCheckbox: boolean;

    public loading: boolean;
    public uploading: boolean;
    private deleteMode: boolean;

    constructor( private clientDocumentService: ClientDocumentService,
        private dragulaService: DragulaService,
        private loginService: LoginService,
        private changeDetector: ChangeDetectorRef ) {
        this.init();
        this.find();

        dragulaService.setOptions( 'clientDocuments-bag', {
            direction: 'vertical',
            /*Elements in source can be reordered*/
            copySortSource: true
        } );
        dragulaService.dropModel.subscribe(() => {
            this.updateOrder();
        },
            () => {
                this.bindError( 'Ocurrió un error al ordenar los archivos.' );
            } );
    }

    private init(): void {
        this.pageHeader = "Archivos de Pago de Patentes";
        this.data = [];

        this.uploaderClientDocument = new FileUploader( {
            url: 'clientPatentDocument/upload',
            removeAfterUpload: true,
            maxFileSize: FILE_MAX_SIZE,
        } );
        this.hasClientDocumentDropZoneOver = false;

        this.loading = false;
        this.uploading = false;
        this.deleteMode = false;

    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        if ( !this.userLogged ) {
            this.loginService.getUserLoggedSubject().subscribe(
                ( userLogged ) => {
                    this.userLogged = userLogged;
                    this.updateUserLogged();
                },
                () => {
                    //Do Nothing.
                } );
        } else {
            this.updateUserLogged();
        }
    }
    private updateUserLogged(): void {
        if ( this.userLogged.isAdmin() ) {
            this.isAdmin = true;
        }
        if ( this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite" ) {
            this.isBank = true;
        }
    }

    private setCheckedDocs() {
        this.bankId = this.userLogged.bank.id;
        for ( let doc of this.data ) {
            if ( doc.bankIds.length > 0 ) {

                if ( doc.bankIds.some( x => x === this.bankId.toString() ) ) {
                    doc.enabled = true;
                }

                else {
                    doc.enabled = false;
                }
            }
        }
    }

    public enableOrDisableDocument() {
        this.disableCheckbox = true;
        let isEnabled = this.clientDocumentSelected.enabled;
        if ( isEnabled ) {
            this.clientDocumentSelected.enabled = false;
            this.clientDocumentSelected.bankIds = this.clientDocumentSelected.bankIds.filter( id => id !== this.bankId.toString() );
            setTimeout(() =>{
                this.disableCheckbox = false; 
                      }, 150);
            this.setCheckedDocs();
            
        }
        else if ( !isEnabled ) {
            this.clientDocumentSelected.enabled = true;
            this.clientDocumentSelected.bankIds.push( this.bankId.toString() );
            setTimeout(() =>{
                this.disableCheckbox = false; 
                      }, 150);
            this.setCheckedDocs();
            
        }
    }

    public updateAllEnabled() {

        this.clearMessages();
        this.loading = true;

        this.clientDocumentService.updateClientDocuments( this.data ).subscribe(
            ( saved: ClientDocument[] ) => {
                this.loading = false;
                this.data = saved;
                this.successMessage = 'Se habilitaron los archivos con éxito.';
                this.setCheckedDocs();
            },
            () => {
                this.bindError( 'Ocurrió un error al habilitar los archivos.' );
            } );
    }

    private find(): void {
        this.clearMessages();

        this.loading = true;
        this.clientDocumentService.getClientPatentDocuments().subscribe(
            ( data ) => {
                this.refreshData( data );
                if ( this.uploading ) {
                    this.successMessage = 'Se guardaron con éxito el/los nuevo/s archivo/s.';
                    this.uploading = false;
                }
            },
            () => {
                this.bindError( 'Ocurrió un error al buscar los archivos.' );
            } );
    }

    private updateOrder(): void {
        this.data.map(( clientDocument ) => {
            clientDocument.order = this.data.indexOf( clientDocument ) + 1;
        } );
        this.saveOrder();
    }

    private saveOrder(): void {
        this.clearMessages();
        this.loading = true;

        this.clientDocumentService.savePatentAll( this.data ).subscribe(
            ( saved: ClientDocument[] ) => {
                this.loading = false;
                this.data = saved;
                if ( this.deleteMode ) {
                    this.deleteMode = false;
                    this.successMessage = 'El archivo se ha eliminado con éxito.';
                } else {
                    this.successMessage = 'El nuevo orden de los archivos se guardó con éxito.';
                }
            },
            () => {
                this.bindError( 'Ocurrió un error al guardar el nuevo orden de los archivos.' );
            } );
    }

    private waitClientDocumentUploaded(): void {
        if ( this.clientDocumentUploading.isSuccess ) {
            this.find()
        } else {
            setTimeout( this.waitClientDocumentUploaded.bind( this ), 3000 );
        }
    }

    public save(): void {
        if ( this.uploaderClientDocument.queue.length > 0 ) {
            this.clearMessages();
            this.loading = true;

            this.uploaderClientDocument.queue.map(( clientDocument ) => {
                clientDocument.upload();
                this.clientDocumentUploading = clientDocument;
                this.uploading = true;
                this.waitClientDocumentUploaded();
            } );
            this.find();

            if ( !this.uploaderClientDocument.isUploading ) {
                this.bindError( 'Ocurrió un error al guardar el/los archivo/s.' );
            }
            this.loading = false;
        }
    }

    private refreshData( data: ClientDocument[] ): void {
        this.data = data;

        if ( this.isBank ) {
            this.setCheckedDocs();
        }

        this.loading = false;
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.error = null;
    }

    public removeClientDocument( deleteModal: any ): void {
        this.clearMessages();
        this.clientDocumentService.delete( this.clientDocumentSelected.id ).subscribe(
            () => {
                deleteModal.hide();
                this.removeClientDocumentFromView( this.clientDocumentSelected );
                this.deleteMode = true;
                this.updateOrder();
            },
            () => {
                this.bindError( 'Ocurrió un error al eliminar el archivo.' );
            } );
    }

    private removeClientDocumentFromView( clientDocument: ClientDocument ): void {
        let index = this.data.indexOf( clientDocument );
        if ( index > -1 ) {
            this.data.splice( index, 1 );
        }
        this.clientDocumentSelected = null;
    }

    public fileOverClientDocument( e: any ): void {
        this.hasClientDocumentDropZoneOver = e;
    }

    private bindError( messageError: string ): void {
        this.loading = false;
        if ( this.error == null ) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/clientPatentFiles/config.clientPatentDocuments.component.ts
 **/